var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-view",style:('background-color: ' + _vm.status.color + '; border-color: ' + _vm.borderColor + '; width: ' + _vm.size + 'px; height: ' + _vm.size + 'px; border-width: ' + _vm.borderSize + 'px;'),attrs:{"title":_vm.status.label}})
}
var staticRenderFns = []

export { render, staticRenderFns }